import styled from 'styled-components'

export const BoxMenuShadow = styled.div`
  transition: all 0.2s linear;
  z-index: 99;
  max-width: 264px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  @media (max-width: 991px) {
    margin-right: 0px;
    max-width: 100%; //change here to make mobile menu
    margin: 0 auto;
    .mobile-menu {
      max-width: 320px;
      left: -320px;
      overflow-y: auto;
      background-color: gray;
      position: fixed;
      top: 77px;
      width: 320px;
      will-change: transform;
      z-index: 10;
    }
    .menu--open {
      left: 0;
    }
  }

  @media (max-height: 851px) {
    .mobile-menu {
      height: 91vh;
    }
  }

  @media (max-height: 740px) {
    .mobile-menu {
      height: 89vh;
    }
  }
`

export const Overlay = styled.div`
  position: fixed;
  top: 77px;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  cursor: pointer;

  &.overlay-is-open {
    bottom: 0;
  }
`

export const ItemWrapper = styled.div`
  position: relative;
  cursor: pointer;
  &.active {
    background-color: #f3f4f6;
    &:after {
      background-color: #142954;
    }
    .icon-img {
      color: #142954 !important;
    }
    .anchor--hover {
      p,
      svg,
      div {
        color: #142954;
      }
    }
  }
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: transparent;
    transition: all 0.3s ease;
  }
  &:hover {
    .icon-img {
      color: #142954 !important;
    }
    .background-hover {
      background-color: #f3f4f6;
      transition: all ease-in-out 0.3s;
    }
    .anchor--hover {
      p,
      svg,
      div {
        color: #142954;
      }
    }
  }
  &:last-child {
    border-bottom: unset;
  }
`